import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-card group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg group-[.toaster]:rounded-md group-[.toaster]:text-[12px] group-[.toaster]:font-sans",
          title: "group-[.toast]:text-[12px] group-[.toast]:font-semibold",
          description: "group-[.toast]:text-muted-foreground group-[.toast]:text-[11px]",
          success: "group-[.toaster]:border-l-4 group-[.toaster]:border-l-[hsl(var(--tone-good))]",
          error: "group-[.toaster]:border-l-4 group-[.toaster]:border-l-[hsl(var(--tone-bad))]",
          warning: "group-[.toaster]:border-l-4 group-[.toaster]:border-l-[hsl(var(--tone-warn))]",
          info: "group-[.toaster]:border-l-4 group-[.toaster]:border-l-[hsl(var(--tone-info))]",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
